
import {validateProperty} from './validate_property';

export function validateLayoutProperty(options) {
    return validateProperty(options, 'layout');
}
